module.exports = __webpack_public_path__ + "img/pay_icon70.b77c80a2.png";